module.exports = __webpack_public_path__ + "img/T40.376537ae.jpg";